import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "Clinician__Alerts",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Alerts", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_5 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-2" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ms-auto d-flex align-items-center cursor-pointer" }
const _hoisted_9 = { class: "icon small" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text font-size-sm fw-bold me-2 blue-text" }, "Sort", -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "mt-3 text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Loading your Alerts", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "mt-5 text-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching your alerts. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_19 = {
  key: 2,
  class: "no-data"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "mb-3" }, " Good Job! There were no issues identified with your visits. ", -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "task-info" }
const _hoisted_23 = { class: "d-flex justify-content-between" }
const _hoisted_24 = { class: "font-size-xs grey-secondary-text" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "grey-secondary-text" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "text-default ms-2 font-size-2xs" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "fas fa-sticky-note orange-note mx-2"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: "fas fa-sticky-note red-note mx-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, { borderClass: "task-alerts-section task-alert-padding" }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          (_ctx.tasksList.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.tasksList.length) + ") ", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, _hoisted_7)), [
            [_directive_custom_popover, { content: _ctx.tooltip, className: 'font-size-sm info-popup' }]
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortByScheduleDate())),
            class: "d-flex flex-column align-items-center"
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.isAscending ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up')
              }, null, 2 /* CLASS */),
              _hoisted_10
            ]),
            _hoisted_11
          ])), [
            [_vShow, _ctx.tasksList.length],
            [_directive_tooltip, { title: `Click to sort visits by schedule date.` }]
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ERROR "),
        (_ctx.hasError && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getReturnedByQATasks()))
              }, "Try Again")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" NO DATA "),
        (_ctx.tasksList.length === 0 && !_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("section", _hoisted_19, _hoisted_21))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" DATA "),
        (_ctx.tasksList.length > 0 && !_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["d-flex flex-column h-100 overflow-auto", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksList, (task) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "alerts",
                  key: task.Id
                }, [
                  _createElementVNode("section", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, " Schedule Date " + _toDisplayString(_ctx.formatDate(task.Date)), 1 /* TEXT */),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.startTask(task)),
                        class: "fw-bold btn btn-primary"
                      }, "Review Visit", 8 /* PROPS */, _hoisted_25)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(task.VisitName) + " - " + _toDisplayString(task.StatusName), 1 /* TEXT */),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      onClick: ($event: any) => (_ctx.viewPatient(task)),
                      class: "fw-bold font-size-base"
                    }, _toDisplayString(task.patientFullName), 9 /* TEXT, PROPS */, _hoisted_27),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ProductPill, {
                          class: "application-name",
                          "product-id": _ctx.getApplicationId(task.Application)
                        }, null, 8 /* PROPS */, ["product-id"]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createTextVNode(_toDisplayString(task.BranchName), 1 /* TEXT */)
                        ])), [
                          [_directive_tooltip, { title: task.agencyTooltip, placement: 'top' }]
                        ])
                      ]),
                      (_ctx.isHomeCare(task.Application))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (task.ReturnComments)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_32, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                            title: _ctx.getReturnComments(task.ReturnComments),
                                            placement: 'top',
                                            className: 'orange-note'
                                        }]
                                ])
                              : _createCommentVNode("v-if", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (task.ReturnComments)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_34, null, 512 /* NEED_PATCH */)), [
                                  [_directive_tooltip, {
                                            title: _ctx.getReturnComments(task.ReturnComments),
                                            placement: 'top',
                                            className: 'red-note'
                                        }]
                                ])
                              : _createCommentVNode("v-if", true)
                          ]))
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}